/* Phosis reviews carousel.
   The Stamped widget renders its review cards into `.stamped-main-widget`, which our
   CSS turns into a horizontal scroll track. This wires the prev/next arrows to it and
   keeps them disabled while there's nothing (or nothing more) to scroll. The widget
   loads async, so we (re)bind on a poll and on Stamped's load event. */
(function () {
  function init(root) {
    var carousel = root || document.querySelector('[data-phosis-reviews]');
    if (!carousel) return;

    var track = carousel.querySelector('#stamped-reviews-tab');
    var prev = carousel.querySelector('[data-reviews-prev]');
    var next = carousel.querySelector('[data-reviews-next]');
    if (!track || !prev || !next) return false;

    if (carousel.dataset.carouselBound === '1') { updateNav(track, prev, next); return true; }
    carousel.dataset.carouselBound = '1';

    /*
     * Susan 08.22 item 7: de pijlen deden niets in Safari, wel in Chrome.
     * De track staat op `scroll-snap-type: x mandatory`. De oude stap was 90% van de
     * trackbreedte, en die landt tussen twee snap-punten in. Safari past de snap dan
     * strikt toe en trekt de scroll terug naar de kaart waar hij vandaan kwam, dus er
     * gebeurt zichtbaar niets. Chrome is soepeler en houdt de nieuwe positie vast.
     *
     * Daarom wordt er nu naar de eerstvolgende kaartrand gescrold in plaats van over
     * een vaste afstand. Dat valt per definitie samen met een snap-punt, dus beide
     * browsers doen hetzelfde, en de kaarten komen ook netjes uitgelijnd te staan.
     */
    function cards() {
      return [].slice.call(track.querySelectorAll('.stamped-review'));
    }
    /*
     * Amjad PHO-1: de pijlen op de homepage deden niets, ook na de fix van Susan
     * item 7. Gemeten: `scrollTo` met `behavior: smooth` verplaatst de track geen
     * pixel en er komt zelfs geen scroll-event, terwijl dezelfde positie direct
     * zetten wel werkt en blijft staan. De widget van Stamped muteert doorlopend
     * (lazy images, herrenders), en elke mutatie breekt de lopende smooth-scroll
     * af voordat die één frame heeft gelopen.
     *
     * Daarom: eerst de nette geanimeerde scroll proberen, en als de track kort
     * daarna nog steeds niet op zijn plek staat, de positie alsnog direct zetten.
     * Waar de animatie wel loopt, verandert er niets aan het gedrag.
     */
    function scrollTrackTo(left) {
      track.scrollTo({ left: left, behavior: 'smooth' });
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - left) > 4) {
          var behavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = left;
          track.style.scrollBehavior = behavior;
        }
      }, 350);
    }
    function scrollToCard(direction) {
      var list = cards();
      if (!list.length) {
        // Geen herkenbare kaarten: terugvallen op een hele trackbreedte.
        scrollTrackTo(track.scrollLeft + direction * track.clientWidth);
        return true;
      }
      var here = track.scrollLeft;
      var target = null;
      if (direction > 0) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].offsetLeft > here + 4) { target = list[i]; break; }
        }
      } else {
        for (var j = list.length - 1; j >= 0; j--) {
          if (list[j].offsetLeft < here - 4) { target = list[j]; break; }
        }
      }
      if (!target) return false;
      scrollTrackTo(target.offsetLeft);
      return true;
    }
    /*
     * Susan 08.22 items 5 en 17: "Carousel only shows 4 reviews even if you try to
     * scroll." Klopte. Stamped pagineert per 4 en levert de rest via zijn eigen
     * pagineringsbalk, maar die verbergen wij met CSS omdat hij niet in het ontwerp
     * past. Gevolg: er staan altijd maar 4 reviews in de DOM en verder kwam je niet.
     *
     * De pijlen lopen nu door naar de volgende Stamped-pagina zodra je aan het eind
     * van de huidige vier bent, en terug naar de vorige aan het begin. Stamped's
     * paginering blijft visueel verborgen, we bedienen hem alleen.
     */
    function pager(kind) {
      if (!carousel) return null;
      var pag = carousel.querySelector('.stamped-pagination');
      if (!pag) return null;
      var li = pag.querySelector('li.' + kind);
      if (!li) return null;
      var a = li.querySelector('a');
      if (!a || a.classList.contains('stamped-link-disabled')) return null;
      return a;
    }
    function goToPage(kind, landOnEnd) {
      var a = pager(kind);
      if (!a) return false;
      a.click();
      /*
       * Stamped rendert de nieuwe pagina asynchroon en vervangt de kaarten in de
       * track. Even pollen tot het aantal kaarten of hun inhoud verandert, dan de
       * scrollpositie zetten: naar het begin bij vooruit, naar het eind bij terug,
       * zodat de leesrichting klopt met de knop die je net indrukte.
       */
      var was = track.innerHTML.length;
      var tries = 0;
      paging = true;
      var poll = setInterval(function () {
        tries += 1;
        if (track.innerHTML.length !== was || tries > 25) {
          clearInterval(poll);
          var place = function () {
            var behavior = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = landOnEnd ? track.scrollWidth : 0;
            track.style.scrollBehavior = behavior;
          };
          /*
           * Ook de scrollpositie een paar keer zetten. Stamped rendert in stappen, en
           * de scrollWidth is bij de eerste poging nog die van de oude set, waardoor
           * terugbladeren niet aan het eind van de vorige pagina landde maar aan het
           * begin.
           */
          place();
          /*
           * Stamped vervangt de kaarten en de pagineringsbalk niet noodzakelijk in
           * dezelfde tick, dus de knopstatus een paar keer herberekenen in plaats van
           * één keer. Anders bleef de vorige-knop uitgeschakeld terwijl Stamped al
           * een vorige pagina aanbood.
           */
          [0, 250, 700].forEach(function (d) {
            setTimeout(function () { place(); updateNav(track, prev, next); }, d);
          });
          setTimeout(function () { paging = false; }, 800);
        }
      }, 120);
      return true;
    }
    /*
     * Op de rand van de track beslist de positie, niet of er toevallig nog een kaart
     * te vinden is. Aan het eind staat de laatste kaart nog steeds rechts van de
     * scrollpositie, dus een zoektocht naar "de volgende kaart" slaagt daar altijd
     * en dan zou er nooit doorgepagineerd worden.
     */
    function atStart() { return track.scrollLeft <= 4; }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 4; }
    prev.addEventListener('click', function () {
      if (atStart()) { goToPage('previous', true); return; }
      if (!scrollToCard(-1)) { goToPage('previous', true); }
    });
    next.addEventListener('click', function () {
      if (atEnd()) { goToPage('next', false); return; }
      if (!scrollToCard(1)) { goToPage('next', false); }
    });
    var paging = false;
    var endTimer = null;
    track.addEventListener('scroll', function () {
      updateNav(track, prev, next);
      /*
       * Susan 08.22 item 14: "You should be able to swipe through all reviews, not
       * just the 1st 4." Op touch zijn de pijlknoppen verborgen (item 6), dus daar is
       * vegen de enige bediening. Kom je vegend aan het eind, dan wordt de volgende
       * Stamped-pagina geladen; aan het begin de vorige. Alleen wanneer de pijlen
       * verborgen zijn, zodat dit op desktop niet met de knoppen gaat vechten.
       */
      var navHidden = !nav() || getComputedStyle(nav()).display === 'none';
      if (!navHidden || paging) return;
      if (endTimer) clearTimeout(endTimer);
      endTimer = setTimeout(function () {
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) { goToPage('next', false); }
        else if (track.scrollLeft <= 4) { goToPage('previous', true); }
      }, 220);
    }, { passive: true });
    function nav() { return carousel.querySelector('.phosis-reviews__nav'); }
    window.addEventListener('resize', function () { updateNav(track, prev, next); });

    /*
     * Stamped vervangt de kaarten en de pagineringsbalk asynchroon, en niet
     * noodzakelijk in dezelfde tick. Een enkele herberekening na het pagineren was
     * daardoor te vroeg: de vorige-knop bleef uitgeschakeld terwijl Stamped allang
     * een vorige pagina aanbood. Een observer op de widget houdt de knoppen
     * gelijk met wat er werkelijk staat, ongeacht de timing.
     */
    if (window.MutationObserver) {
      var settle = null;
      new MutationObserver(function () {
        if (settle) clearTimeout(settle);
        settle = setTimeout(function () { updateNav(track, prev, next); }, 60);
      }).observe(carousel, { childList: true, subtree: true });
    }

    updateNav(track, prev, next);
    return true;
  }

  function updateNav(track, prev, next) {
    /*
     * Stamped vervangt de track af en toe door een nieuwe node. De verwijzing die
     * wij vasthouden hangt dan los van de pagina en `closest` levert niets op,
     * waarna elke herberekening een fout gooide. Er is op dat moment ook niets te
     * berekenen, dus dan stoppen we hier.
     */
    var carousel = track.closest('[data-phosis-reviews]');
    if (!carousel) return;
    var scrollable = track.scrollWidth - track.clientWidth > 4;
    /*
     * De pijlen mogen niet meer verdwijnen zodra de huidige vier kaarten passen: er
     * kunnen nog Stamped-pagina's achter zitten. Ze verdwijnen alleen als er noch
     * ruimte om te scrollen is, noch een volgende of vorige pagina bestaat.
     */
    function pageLink(kind) {
      var pag = carousel.querySelector('.stamped-pagination');
      if (!pag) return null;
      var li = pag.querySelector('li.' + kind);
      var a = li ? li.querySelector('a') : null;
      return a && !a.classList.contains('stamped-link-disabled') ? a : null;
    }
    /*
     * Bewust niet uitschakelen op basis van Stamped's eigen link-status. Die loopt na
     * een paginawissel een paar honderd milliseconden achter, en in dat venster
     * stond de vorige-knop uitgeschakeld en slikte hij de klik van iemand die meteen
     * terug wilde. De knoppen blijven daarom actief zolang er meer dan één pagina is;
     * op de echte grens doet Stamped's link niets en gebeurt er simpelweg niets.
     */
    var pag = carousel.querySelector('.stamped-pagination');
    var pageCount = pag ? pag.querySelectorAll('li.page').length : 0;
    var multiPage = pageCount > 1;
    var nav = carousel.querySelector('.phosis-reviews__nav');
    if (nav) nav.style.display = (scrollable || multiPage) ? '' : 'none';
    if (multiPage) {
      prev.disabled = false;
      next.disabled = false;
    } else {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
  }

  function ready() {
    // The Stamped track mounts asynchronously — poll for it, then stop once bound.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (init() || tries >= 40) clearInterval(timer);
    }, 400);
    document.addEventListener('stamped:reviews:load', function () { init(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
